import { render, staticRenderFns } from "./files-label-add-edit.vue?vue&type=template&id=8814152e&scoped=true&"
import script from "./files-label-add-edit.vue?vue&type=script&lang=ts&"
export * from "./files-label-add-edit.vue?vue&type=script&lang=ts&"
import style0 from "./files-label-add-edit.vue?vue&type=style&index=0&id=8814152e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8814152e",
  null
  
)

export default component.exports